// eslint-disable-next-line
/* eslint-disable */

import axios from 'axios'

const config = {
  baseURL: `${process.env.VUE_APP_AI_CHATBOT_API_URL}/`,
  headers: <any>{
    'Content-type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
}

export default axios.create(config)
